import {
  AUTHENTICATION_FAILED,
  USER_AUTHENTICATED,
  AUTENTICATION_TWO_FACTORY,
  USER_LOGOUT,
  ATUALIZAR_EMPRESAS, FILTRAR_SELECAO_EMPRESA, LIMPAR_FILTRO_SELECAO_EMPRESA
} from '../actions/types'
import { getAuthentication } from '../security/securityContext'
import { ordenarEmpresas } from '../actions/util/authenticationJwtActions';

const INITIAL_STATE = getAuthentication() || { isAuthenticated: false }

const initialState = undefined

export default (state = INITIAL_STATE, action = initialState) => {
  switch (action.type) {
    case AUTHENTICATION_FAILED:
      return action.payload;
    case USER_AUTHENTICATED:
      return action.payload;
    case USER_LOGOUT: {
      return action.payload
    }
    case AUTENTICATION_TWO_FACTORY: {
      return action.payload;
    }
    case ATUALIZAR_EMPRESAS: {
      if (state.isAuthenticated) {
        const empreasOrdenadas = ordenarEmpresas(action.payload.data);
        const authentication = {
          empresas: empreasOrdenadas,
          empresasSelecao: empreasOrdenadas,
          isAuthenticated: state.isAuthenticated,
          nomeUsuario: state.nomeUsuario,
          nomeUsuarioComNumero: state.nomeUsuarioComNumero,
          idUsuario: state.idUsuario,
          tokenJwt: state.tokenJwt,
          username: state.username
        }
        return authentication
      }
      return state
    }

    case FILTRAR_SELECAO_EMPRESA: {
      const retorno = action.payload.empresas.filter(
        l => (l.nome.toLowerCase().includes(action.payload.texto.toLowerCase()) || (l.nomeFantasia.toLowerCase().includes(action.payload.texto.toLowerCase())))
      );
      return {
        ...state,
        empresasSelecao: retorno
      };
    }

    case LIMPAR_FILTRO_SELECAO_EMPRESA: {
      return {
        ...state,
        empresasSelecao: state.empresas
      };
    }

    default:
      return state
  }
}
